<template>
  <v-menu v-model="dateMenu" :close-on-content-click="false" max-width="290">
    <template v-slot:activator="{ on }">
      <TextField
        :loading="loading"
        :label="inputLabel"
        :value="computedDateFormattedDatefns"
        :disabled="disabled"
        v-on="on"
        @click:clear="date = null"
        readonly
      />
    </template>
    <v-date-picker v-model="innerValue" color="primary" @change="dateMenu = false"></v-date-picker>
  </v-menu>
</template>
<script>
import TextField from "@/components/TextField";
import format from "date-fns/fp/format";
export default {
  name: "DateField",
  components: {
    TextField
  },
  data: () => ({
    date: "",
    dateMenu: false,
    innerValue: ""
  }),
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {
    isValidDate(date) {
      return date instanceof Date && !isNaN(date.getTime());
    },
    handleFocus() {
      this.dateMenu = true;
      return;
    },
    handleBlur() {
      this.dateMenu = false;
      return;
    }
  },
  computed: {
    computedDateFormattedDatefns() {
      //   return format(new Date(), "dd MMM yyyy");
      let dateObj;

      dateObj = typeof this.date == "string" ? new Date(this.date) : this.date;

      if ((!this.date || this.date === "") && this.setByDefaultDate) {
        dateObj = new Date();
      }

      if (!this.isValidDate(dateObj)) {
        dateObj = new Date(this.date.replace(/-/g, "/"));
      }

      return dateObj !== "" && dateObj != "Invalid Date" && dateObj !== null ? format("dd-MM-yyyy", dateObj) : null;
    }
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.date = newVal;
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
    // date: {
    //   handler(date) {
    //     const entity = this.inputLabel.toLowerCase();
    //   }
    // }
  },
  props: {
    inputLabel: {
      type: String,
      default() {
        return "";
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showIcons: {
      default: false,
      type: Boolean
    },
    showOnlyErrorIcons: {
      default: false,
      type: Boolean
    },
    errorMessage: {
      required: false,
      type: String
    },
    setByDefaultDate: {
      type: Boolean,
      default() {
        return false;
      }
    },
    value: {
      default: "",
      type: null
    }
  }
};
</script>
